import './layout.pcss';
import Vue from 'vue';
import modal from '../../common/components/modal/modal.vue';
import Accordion from '../../common/components/accordion/accordion.vue';
import AccordionItem from '../../common/components/accordion-item/accordion-item.vue';

import layoutBase from '../layout-base';

Vue.component(
	'article-distributor',
	() => import(/* webpackChunkName: 'applications/article-distributor' */ '../../applications/article-distributor/article-distributor')
);
Vue.component(
	'article-similar',
	() => import(/* webpackChunkName: 'applications/article-similar' */ '../../applications/article-similar/article-similar')
);
Vue.component(
	'search-results',
	() => import(/* webpackChunkName: 'applications/search-results' */ '../../applications/search-results/search-results')
);
Vue.component('accordion', Accordion);
Vue.component('accordion-item', AccordionItem);

/* eslint-disable no-new*/
new Vue({
	extends: layoutBase,
	el: '[data-layout-id=AALT-app]',
	components: {
		modal
	}
});
/* eslint-enable*/
